export const FETCH_PROJECT_LIST = 'FETCH_PROJECT_LIST';
export const TEST='TEST';
export const FETCH_SURVEY_ID = 'FETCH_SURVEY_ID';
export const FETCH_SURVEY_NAME = 'FETCH_SURVEY_NAME';
export const ON_CHANGE_DATA = 'ON_CHANGE_DATA';
export const FETCH_CODE = 'FETCH_CODE';



